export default __webpack_public_path__ + "static/media/gwn45.24445087.webp";